// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1BFXp","box":"WorkspacesBox_box__3lsJD","node":"WorkspacesBox_node__1xHB3"};